import { createFileRoute } from "@tanstack/react-router";
import { MarketingPage } from "@/content-site/components/marketing-page";
import { loadContentPage, contentHead } from "@/content-site/lib/page";
export const Route = createFileRoute("/_content/compare/$slug/")({
  loader: ({ params }) => loadContentPage(["compare", params.slug]),
  head: ({ loaderData }) => contentHead(loaderData),
  component: Page,
});
function Page() {
  return <MarketingPage data={Route.useLoaderData()} />;
}
